export { default } from './TermsDialogView';



// WEBPACK FOOTER //
// ./src/components/views/TermsDialogView/index.js